import { render } from "./VoucherPurchaseSuccess.vue?vue&type=template&id=748a6fef"
import script from "./VoucherPurchaseSuccess.vue?vue&type=script&lang=js"
export * from "./VoucherPurchaseSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__